function getWindowHeight() {
  return window.innerHeight;
}

export default getWindowHeight;
